"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactJss = _interopRequireDefault(require("react-jss"));
var _excluded = ["children", "className", "classes"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var styles = {
  svgIcon: {
    fill: 'currentColor'
  }
};
var SvgIcon = function SvgIcon(props) {
  var children = props.children,
    className = props.className,
    classes = props.classes,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className, classes.svgIcon)
  }, other), children);
};
SvgIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  classes: _propTypes["default"].object.isRequired,
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  viewBox: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number
} : {};
SvgIcon.defaultProps = {
  className: null,
  viewBox: '0 0 32 32',
  width: 32,
  height: 32
};
var _default = exports["default"] = (0, _reactJss["default"])(styles)(SvgIcon);
module.exports = exports.default;